var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEverDrivenLogoRgb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 525.87 108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#3573b0;}.c{fill:#26265e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,78.89c0-16.14,12.3-29.11,27.53-29.11s26.29,9.37,26.74,29.23H6.66c0,12.64,9.25,23.02,22,23.02,7.67,0,13.43-2.93,17.6-6.88l4.06,4.51c-4.85,4.51-11.96,8.35-21.67,8.35-16.7,0-28.66-13.09-28.66-29.11Zm7.11-5.64H47.17c-1.24-11.62-9.82-17.49-19.86-17.49s-18.17,7-20.2,17.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M54.62,50.68h7.22l21.44,43.78,21.33-43.78h7.22l-28.55,57.32-28.66-57.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M112.62,78.89c0-16.14,12.3-29.11,27.53-29.11s26.29,9.37,26.74,29.23h-47.62c0,12.64,9.25,23.02,22,23.02,7.67,0,13.43-2.93,17.6-6.88l4.06,4.51c-4.85,4.51-11.96,8.35-21.67,8.35-16.7,0-28.66-13.09-28.66-29.11Zm7.11-5.64h40.06c-1.24-11.62-9.82-17.49-19.86-17.49s-18.17,7-20.2,17.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M179.76,50.68h6.43v8.58c3.84-5.75,10.04-8.91,16.93-8.91,1.24,0,2.48,.11,3.72,.34v6.66c-1.47-.34-2.93-.56-4.4-.56-7.33,0-13.77,4.51-16.25,11.73v38.59h-6.43V50.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M250.17,103.83c-3.27,2.71-7.79,4.17-12.41,4.17-16.7,0-27.31-13.65-27.31-29.11s10.61-29.11,27.31-29.11c4.63,0,9.14,1.58,12.41,4.29V26.98h17.04V107.1h-17.04v-3.27Zm0-16.02v-17.72c-2.37-3.05-5.42-4.74-9.59-4.74-8.12,0-12.98,6.09-12.98,13.54s4.85,13.54,12.98,13.54c4.17,0,7.22-1.58,9.59-4.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M279.42,50.68h17.04v4.97c3.16-3.84,7.33-5.87,12.86-5.87,1.81,0,3.95,.23,6.09,.9v17.72c-2.59-1.35-5.75-1.92-8.69-1.92-3.5,0-7.56,1.35-10.27,3.72v36.9h-17.04V50.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M323.66,50.68h17.15v56.42h-17.15V50.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M407.27,78.89c0-16.59,11.74-29.11,29.11-29.11,14.33,0,27.19,9.37,27.19,27.19,0,1.58-.11,3.27-.34,4.97h-39.61c.79,7.56,7.22,10.49,12.3,10.49,5.98,0,9.82-2.93,12.07-7.11l13.54,9.14c-5.19,8.13-14.33,13.54-25.5,13.54-14.89,0-28.77-11.73-28.77-29.11Zm16.47-6.88h23.02c-.9-5.98-5.87-8.58-11.4-8.58-4.06,0-10.04,1.81-11.62,8.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M471.25,50.68h17.04v3.5c3.39-2.82,8.01-4.4,12.98-4.4,15.91,0,24.6,10.61,24.6,25.84v31.48h-17.04v-28.44c0-7.56-2.93-13.31-10.38-13.31-3.27,0-7.33,1.69-10.16,4.85v36.9h-17.04V50.68Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M346.02,50.14h19.67l13.22,24.64,13.22-24.64h19.66l-32.89,57.42-32.89-57.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M368.4,35.81c0-5.8,4.7-10.51,10.51-10.51s10.51,4.7,10.51,10.51-4.7,10.51-10.51,10.51-10.51-4.7-10.51-10.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M364.22,46.32c-2.13-2.96-3.4-6.58-3.4-10.51,0-9.99,8.1-18.09,18.09-18.09s18.09,8.1,18.09,18.09c0,3.93-1.27,7.54-3.4,10.51h19.55c1.02-3.32,1.57-6.85,1.57-10.51,0-19.78-16.03-35.81-35.81-35.81s-35.81,16.03-35.81,35.81c0,3.66,.55,7.18,1.57,10.51h19.55Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEverDrivenLogoRgb);
export default __webpack_public_path__ + "static/media/everDrivenLogoRGB.f4af7d349dec270fd9f0f2d68598b592.svg";
export { ForwardRef as ReactComponent };